var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8764 25.0896L21.8767 25.09C23.8361 27.7165 26.4935 29.0316 29.1241 29.0758C31.768 29.1201 34.4523 27.8953 36.496 25.3362L21.8764 25.0896ZM21.8764 25.0896C20.0263 22.6145 18.1733 19.0718 17.362 16.0355C18.4862 15.314 19.2464 14.0527 19.2698 12.6073C19.3068 10.3271 17.5202 8.45057 15.2704 8.41281C13.019 8.37503 11.174 10.2066 11.1373 12.4708C11.108 14.2787 12.233 15.8541 13.8409 16.4352C13.7125 18.3553 13.1915 20.7921 12.3318 23.0133C11.3883 25.4514 10.0909 27.4889 8.58796 28.38L8.19003 28.6159M21.8764 25.0896L8.19003 28.6159M8.19003 28.6159L8.30177 29.065M8.19003 28.6159L8.30177 29.065M8.30177 29.065L10.282 37.0243L10.3975 37.4884M8.30177 29.065L10.3975 37.4884M10.3975 37.4884L10.8756 37.4964M10.3975 37.4884L10.8756 37.4964M10.8756 37.4964L47.1178 38.1047L47.5959 38.1127M10.8756 37.4964L47.5959 38.1127M47.5959 38.1127L47.7263 37.6527M47.5959 38.1127L47.7263 37.6527M47.7263 37.6527L49.9635 29.7642L50.0898 29.319M47.7263 37.6527L50.0898 29.319M50.0898 29.319L49.6997 29.0699M50.0898 29.319L49.6997 29.0699M49.6997 29.0699C48.2267 28.1291 46.9961 26.0459 46.1319 23.5753C45.345 21.3252 44.9032 18.8728 44.8369 16.9554C46.4627 16.4285 47.6381 14.8917 47.6674 13.0839C47.7044 10.8036 45.9179 8.92713 43.6681 8.88938L43.64 8.88891C41.3728 8.85086 39.5435 10.6843 39.5068 12.9469M49.6997 29.0699L39.5068 12.9469M39.5068 12.9469C39.4834 14.3923 40.2023 15.6784 41.3024 16.4373M39.5068 12.9469L41.3024 16.4373M41.3024 16.4373C40.3935 19.4425 38.4274 22.9086 36.4967 25.3354L41.3024 16.4373Z",
    fill: "url(#paint0_linear_1053_2263)",
    stroke: "url(#paint1_linear_1053_2263)",
    strokeWidth: 1.24415
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.584 36.9623L48.962 36.9519L48.9525 37.5382C48.7111 38.269 48.0615 38.979 46.958 39.6352C45.8046 40.3211 44.2336 40.9001 42.3567 41.3602C38.6067 42.2793 33.7554 42.6949 28.8897 42.6133C24.024 42.5316 19.1879 41.9534 15.468 40.9089C13.6061 40.3861 12.0535 39.7546 10.9217 39.0303C9.78119 38.3005 9.14549 37.5278 8.96036 36.749L7.73318 36.8821L7.63648 42.8466C7.62855 43.3359 7.73169 43.7776 7.98213 44.2134C8.49305 45.1199 9.4459 45.9197 10.668 46.6127C11.9025 47.3127 13.4691 47.9359 15.2835 48.4612C18.9136 49.5121 23.5993 50.1891 28.7532 50.2756C33.9071 50.3621 38.6122 49.8427 42.2744 48.9141C44.1048 48.45 45.6908 47.8797 46.9473 47.2215C48.1911 46.57 49.1694 45.8026 49.7094 44.9137C49.9739 44.4866 50.0913 44.0485 50.0992 43.5592L50.1938 37.7278L50.3972 36.976L49.5981 36.9626L49.584 36.9623Z",
    fill: "#FEBE30",
    stroke: "url(#paint2_linear_1053_2263)",
    strokeWidth: 1.24415
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7877 14.0598L56.9986 13.4414L56.3705 13.2608C53.9135 12.5543 51.3735 14.0277 50.7016 16.5169C50.2772 18.0741 50.6885 19.6707 51.6587 20.8165C50.8703 22.5494 49.4353 24.337 47.6481 25.5351C45.7456 26.8105 43.5006 27.3856 41.2215 26.607C38.5012 25.6754 36.4869 23.3092 34.9868 20.3148C33.5663 17.4793 32.6491 14.163 32.0351 11.1995C33.7091 10.2835 34.8586 8.50117 34.8922 6.43342C34.9414 3.39677 32.5622 0.879145 29.5516 0.828622C26.541 0.778098 24.0816 3.21452 24.0323 6.25117C23.9988 8.31855 25.0895 10.1382 26.7325 11.11C26.0165 14.052 24.9924 17.3357 23.4824 20.122C21.8877 23.0646 19.8012 25.3616 17.0525 26.2014C14.7493 26.9032 12.5206 26.2529 10.6587 24.9142C8.90949 23.6566 7.53356 21.822 6.80785 20.0648C7.81512 18.9522 8.27837 17.3699 7.90473 15.7991C7.31359 13.3019 4.83775 11.7476 2.34911 12.353L1.70892 12.5087L1.90156 13.139C4.35179 21.1554 6.41429 29.6463 7.71245 37.6906L7.71273 37.6924C7.89424 38.7975 8.72847 39.7444 9.87534 40.5315C11.0377 41.3292 12.6198 42.0324 14.4967 42.6217C18.2553 43.802 23.3074 44.5603 28.8412 44.6531C34.3752 44.746 39.4527 44.154 43.2492 43.0988C45.1449 42.5719 46.7494 41.9218 47.9362 41.1642C49.1067 40.4171 49.9709 39.4999 50.1841 38.4031C51.7423 30.407 54.0786 22.0042 56.7877 14.0598Z",
    fill: "url(#paint3_linear_1053_2263)",
    stroke: "url(#paint4_linear_1053_2263)",
    strokeWidth: 1.24415
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3007 28.9115L29.1549 26.0623L34.8996 29.1062L33.9142 39.5775L28.914 40.9244L23.9602 39.4104L23.3007 28.9115Z",
    fill: "url(#paint5_linear_1053_2263)",
    stroke: "url(#paint6_linear_1053_2263)",
    strokeWidth: 1.10332
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1053_2263",
    x1: 29.2372,
    y1: 38.7104,
    x2: 29.2826,
    y2: 11.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151531,
    stopColor: "#FFC956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1053_2263",
    x1: 29.4592,
    y1: 9.27309,
    x2: 28.9909,
    y2: 37.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1053_2263",
    x1: 28.9716,
    y1: 37.2386,
    x2: 28.9589,
    y2: 59.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660765,
    stopColor: "#FFF49F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEFAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1053_2263",
    x1: 29.1521,
    y1: 46.3677,
    x2: 29.1288,
    y2: 5.31079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151531,
    stopColor: "#FFC956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF069"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1053_2263",
    x1: 29.5416,
    y1: 1.45062,
    x2: 29.5131,
    y2: 51.3442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566927,
    stopColor: "#A3994D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816948,
    stopColor: "#FFF9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#918101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1053_2263",
    x1: 24.7976,
    y1: 30.8152,
    x2: 30.3601,
    y2: 31.6708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFACA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8B5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1053_2263",
    x1: 29.1479,
    y1: 26.0622,
    x2: 28.8154,
    y2: 45.8781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD84E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.11575e412e1a609d95dff0810a3d5add.svg";
export { ForwardRef as ReactComponent };